<template>
    <div>
        <encabezado></encabezado>
        <template v-if="this.tokenOk">
            <div class="row">
                <div class="col-md-6 offset-md-3 col-10 offset-1">
                    <span class="text--s align-center">Introduzca su nueva contraseña</span>
                    <v-text-field v-model="password1" type="password" color="#BBDC55" label="Contraseña"></v-text-field>
                    <v-text-field v-model="password2" type="password" color="#BBDC55" label="Repita la contraseña"></v-text-field>
                    <p v-if="!checkPasswords" class="text--m">Las contraseñas no coinciden</p>
                    <v-btn color="#C2E500" @click="cambiarPassword" block>Cambiar contraseña</v-btn>
                </div>
            </div>
        </template>
        <pie></pie>
    </div>
</template>

<script>
    export default {
        components: {
            modal: () => import("@/components/Dinamicos/modal"),
            encabezado: () => import("@/components/newEncabezado"),
            pie: () => import('@/components/newPie')
        },

        data: () => ({
            token: "",
            aplicationCode: "WSATT",
            tokenOk: false,
            password1: "",
            password2: "",
            idCliente: "",
        }),
        methods: {
            cambiarPassword(){
                let passwordData = {
                    password1: this.password1,
                    password2: this.password2,
                    idCliente: this.idCliente,
                    aplicationCode: this.aplicationCode
                }
                this.$API.cambiarPasswordParticular(passwordData).then((response) => {
                    if (response.codigo === 0) {
                        console.log("Ok cambio contraseña");
                        this.$router.push("/particularCR");
                    }
                })
            }
        },
        computed: {
            checkPasswords() {
                return (
                    this.password1 === "" ||
                    this.password2 === "" ||
                    this.password1 === this.password2
                );
            },
        },
        created() {
            this.token = this.$route.query.recover
            if (this.token != null && this.token != undefined && this.token != "") {
                let tokenData = {
                    token: this.token
                }
                this.$API.comprobarTokenRecuperarPassword(tokenData).then((response) => {
                    if (response.codigo === 0) {
                        console.log("Ok token");
                        this.tokenOk = true
                        this.idCliente = response.idCliente
                    }
                })
            }
        }
    }
</script>

<style>
</style>